import { Box, Button, ButtonProps, Stack, styled } from '@mui/material';

import React, { AriaAttributes, ReactElement, ReactNode, useId } from 'react';

type CircleIconButtonProps = ButtonProps &
  AriaAttributes & {
    icon: ReactElement;
    label?: ReactNode;
    rotateIcon?: number;
  };

const StyledButton = styled(Button)(() => ({
  padding: 0
}));

type NewButtonProps = ButtonProps &
  Partial<Pick<CircleIconButtonProps, 'rotateIcon'>>;

const StyledBox = styled(Box, {
  shouldForwardProp: prop => !['icon, label'].includes(prop.toString())
})<NewButtonProps>(({ rotateIcon = 0, ...props }) => {
  return {
    '& svg': {
      height: props.theme.spacing(4),
      transform: `rotate(${rotateIcon}deg)`,
      width: 'auto'
    },
    alignSelf: 'center',
    backgroundColor: props.theme.palette.white.main,
    border: `1px solid ${props.theme.palette[props.color]?.main}`,
    borderRadius: '100%',
    color: props.theme.palette[props.color]?.main,
    padding: `${props.theme.spacing(2)} ${props.theme.spacing(3)}`
  };
});

const CircleIconButton: React.FC<CircleIconButtonProps> = ({ ...props }) => {
  const id = useId();
  return (
    <StyledButton data-testid={id} {...props} variant='text'>
      <Stack gap={2}>
        <StyledBox color={props.color}>
          {React.cloneElement(props.icon, { color: props.color })}
        </StyledBox>
        {props.label}
      </Stack>
    </StyledButton>
  );
};

export default CircleIconButton;
